import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Modal, IconButton } from 'shared-components';
// Import Global Components
import { isHRB, isMoniecorp, isOxford, getCardholderSupportEmail } from 'shared-components/src/utils/whitelabel';
import RouteGuard from '../components/Route';
// Import Layouts
import NotFound from '../layouts/NotFound';
import Private from './Private';
import TaxDocumentViewer from './TaxDocuments/Viewer';
// Import Local Components
import Header from './Auth/components/Header';
import Login from './Auth/routes/Login';
import Activate from './Auth/routes/Activate';
import Alert from '../components/Alert';
// import Register from "./layouts/Register";
import Register from './Auth/routes/Register';
import ForgotPassword from './Auth/routes/ForgotPassword';
import ForgotUsername from './Auth/routes/ForgotUsername';
import ResetPassword from './Auth/routes/ResetPassword';
import MFASetup from './Auth/routes/MFASetup';
import MFAVerify from './Auth/routes/MFAVerify';
import RegisterSetPin from './Auth/routes/RegisterSetPin';
import CardProxyPage from './Auth/routes/CardholderAgreement';
// Import Layouts
import Body from '../layouts/Body';
import Shell from '../layouts/Shell';
import Footer from '../layouts/Footer';
import { Base } from './Auth/styles';
// Import redirect device component
import RedirectToDevicePortal from './RedirectToDevicePortal';
import Balance from './Auth/routes/Balance';
import CamsLogin from './Auth/routes/CamsLogin';
import CamsRegister from './Auth/routes/CamsRegister';
import RbcOnboarding from './Auth/routes/RbcOnboarding';
import ZohoDeskASAP from '../components/ZohoDeskASAP';
import RefundPage from './Disbursements/Redeem';
import DisbursementWrapper from './Disbursements';
import RefundVerification from './Disbursements/Verification';
import TransferOptions from './Disbursements/TransferOptions';
import InteracTransfer from './Disbursements/InteracTransfer';
import VisaDirectTransfer from './Disbursements/VisaDirectTransfer';
import CreateAccount from './Disbursements/CreateAccount';
import TransactionSuccess from './Disbursements/TransactionSuccess';
import InteracSuccess from './Disbursements/InteracTransfer/InteracSuccess';
import VerificationFailed from './Disbursements/VerificationFailed';
import AccountCreated from './Disbursements/AccountCreated';
import SessionExpired from './Disbursements/SessionTerminated';
import LinkExpired from './Disbursements/LinkExpired';

export default props => {
  const isHRBClient = isHRB();
  const isMonieCorpClient = isMoniecorp();
  const intl = useIntl();
  const [e6DetailedMigrationModal, setE6DetailedMigrationModal] = useState(false);

  const shouldShowSupportChatbot = () => {
    // is oxford or path starts with disbursements
    if (isOxford() || window.location.pathname.startsWith('/disbursements')) {
      return false;
    }

    return true;
  };

  // eslint-disable-next-line react/destructuring-assignment, react/prop-types
  const callCenterBanner = props && props.callCenterBanner;
  // eslint-disable-next-line react/destructuring-assignment, react/prop-types
  const e6MigrationBanner = props && props.e6MigrationBanner;

  const handleClick = () => {
    setE6DetailedMigrationModal(true);
  };

  return (
    <Shell>
      <Routes>
        {isMonieCorpClient && (
          <Route
            path="/"
            element={<Navigate to="/checkcardbalance" replace />}
          />
        )}
        <Route
          path="/cardholder-agreement"
          element={
            <Base>
              <Header {...props} />
              <Body>
                <CardProxyPage />
                <Footer />
              </Body>
            </Base>
          }
        />
        <Route
          path="/login"
          element={
            <Base>
              <Header {...props} />
              <Body>
                {
                  e6MigrationBanner && (
                    <Alert
                      // eslint-disable-next-line dot-notation
                      alert={intl.messages['e6-migration-banner-short-alert']}
                      type='warn'
                      alertFor='e6-migration-banner-short'
                      style={{
                        display: 'inline',
                      }}
                      values={{
                        a: chunks => (
                          <button
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              handleClick();
                            }}
                            style={{
                              textDecoration: 'underline',
                              color: 'inherit',
                            }}
                          >
                            {chunks}
                          </button>
                        ),
                        strong: chunks => (
                          <strong>
                            {chunks}
                          </strong>
                        )
                      }}
                    />
                  )
                }
                {
                  callCenterBanner && (
                    <Alert
                      // eslint-disable-next-line dot-notation
                      alert={intl.messages['cardholder_support_email']}
                      type='warn'
                      alertFor='call-center-banner'
                      values={{
                        cardholder_support_email: getCardholderSupportEmail()
                      }}
                    />
                  )
                }
                {
                  e6DetailedMigrationModal && (
                    <Modal>
                      <IconButton
                        iconType='x'
                        onClick={()=> setE6DetailedMigrationModal(false)}
                        style={{
                          position: 'absolute',
                          top: '30px',
                          right: '30px'
                        }}
                      />
                      <div style={{ padding: '20px', maxWidth: '600px' }}>
                        <h2>{intl.messages['maintenance-notification-header']}</h2>
                        <br />
                        <p>{intl.messages['maintenance-notification-greeting']}</p>
                        <br />
                        <p>
                          {intl.messages['maintenance-notification-body1-1']} <strong>{intl.messages['maintenance-notification-body1-2']}</strong> {intl.messages['maintenance-notification-body1-3']}
                          <strong> {intl.messages['maintenance-notification-body1-4']}</strong>. {intl.messages['maintenance-notification-body1-5']}
                          <strong> {intl.messages['maintenance-notification-body1-6']}</strong> ({intl.messages['maintenance-notification-body1-7']} <strong>{intl.messages['maintenance-notification-body1-8']}</strong>).
                        </p>
                        <br />
                        <h3>{intl.messages['impact-on-services']}</h3>
                        <p>{intl.messages['maintenance-notification-body2-1']} <strong>{intl.messages['maintenance-notification-body2-2']}</strong> {intl.messages['maintenance-notification-body2-3']}</p>
                        <br />
                        <ul style={{ listStyleType: 'disc', margin: '0' }}>
                          <li>{intl.messages['maintenance-impact-item1']}</li>
                          <li>{intl.messages['maintenance-impact-item2']}</li>
                          <li>{intl.messages['maintenance-impact-item3']}</li>
                          <li>{intl.messages['maintenance-impact-item4']}</li>
                        </ul>
                        <br />
                        <p>
                          {intl.messages['maintenance-notification-body3-1']} <strong>{intl.messages['maintenance-notification-body3-2']}</strong>, {intl.messages['maintenance-notification-body3-3']} <strong>{intl.messages['maintenance-notification-body3-4']}</strong>.
                        </p>
                        <br />
                        <p>
                          {intl.messages['apology-message']}
                        </p>
                        <br />
                        <p><strong>{intl.messages['thank-you-message']}</strong></p>
                      </div>
                    </Modal>
                  )
                }
                <Login />
                <Footer />
              </Body>
            </Base>
          }
        />
        <Route
          path="/activate"
          element={
            <Base>
              <Header {...props} />
              <Body>
                <Activate />
                <Footer />
              </Body>
            </Base>
          }
        />
        <Route
          path="/checkcardbalance"
          element={
            <Base>
              <Header {...props} />
              <Body>
                <Balance />
                <Footer />
              </Body>
            </Base>
          }
        />
        <Route
          path="/cams"
          element={<CamsLogin locale={props.locale} setLocale={props.setLocale} />}
        />
        <Route
          path="/cams-register"
          element={<CamsRegister locale={props.locale} setLocale={props.setLocale} />}
        />
        {/* Standalone RBC RightPay onboarding, outside the portal shell by design */}
        <Route
          path="/rbc"
          element={<RbcOnboarding locale={props.locale} setLocale={props.setLocale} />}
        />
        <Route
          path="/register"
          element={
            <Base>
              <Header {...props} />
              <Body>
                <Register />
                <Footer />
              </Body>
            </Base>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <Base>
              <Header {...props} />
              <Body>
                <ForgotPassword />
                <Footer />
              </Body>
            </Base>
          }
        />
        <Route
          path="/forgot-username"
          element={
            <Base>
              <Header {...props} />
              <Body>
                <ForgotUsername />
                <Footer />
              </Body>
            </Base>
          }
        />
        <Route
          path="/reset-password"
          element={
            <Base>
              <Header {...props} />
              <Body>
                <ResetPassword />
                <Footer />
              </Body>
            </Base>
          }
        />
        <Route
          path="/mfa-setup"
          element={
            <Base>
              <Header {...props} />
              <Body>
                <MFASetup />
                <Footer />
              </Body>
            </Base>
          }
        />
        <Route
          path="/mfa-verify"
          element={
            <Base>
              <Header {...props} />
              <Body>
                <MFAVerify />
                <Footer />
              </Body>
            </Base>
          }
        />
        <Route
          path="/register-set-pin"
          element={
            <Base>
              <Header {...props} />
              <Body>
                <RegisterSetPin />
                <Footer />
              </Body>
            </Base>
          }
        />
        <Route
          path="/disbursements/*"
          element={
            <Base>
              <DisbursementWrapper {...props}>
                <Routes>
                  <Route path="redeem" element={<RefundPage />} />
                  <Route path="verification" element={<RefundVerification />} />
                  <Route path="verification-failed" element={<VerificationFailed />} />
                  <Route path="transfer-options" element={<TransferOptions />} />
                  <Route path="interac-transfer" element={<InteracTransfer />} />
                  <Route path="interac-success" element={<InteracSuccess />} />
                  <Route path="visa-direct" element={<VisaDirectTransfer />} />
                  <Route path="create-account" element={<CreateAccount />} />
                  <Route path="account-created" element={<AccountCreated />} />
                  <Route path="transfer-success" element={<TransactionSuccess />} />
                  <Route path="session-terminated" element={<SessionExpired />} />
                  <Route path="link-expired" element={<LinkExpired />} />
                </Routes>
              </DisbursementWrapper>
            </Base>
          }
        />
        {
          isHRBClient && (
            <Route
              path="/redirect-to-device-portal"
              element={
                <Base>
                  <Header {...props} />
                  <Body>
                    <RedirectToDevicePortal />
                    <Footer />
                  </Body>
                </Base>
              }
            />
          )
        }
        <Route
          path="/tax-documents/:year"
          element={
            <RouteGuard priv>
              <TaxDocumentViewer />
            </RouteGuard>
          }
        />
        <Route
          path="/*"
          element={
            <RouteGuard priv>
              <Private {...props} />
            </RouteGuard>
          }
        />
      </Routes>
      {/* Zoho asapApp */}
      {shouldShowSupportChatbot() && <ZohoDeskASAP isHRBClient={isHRBClient} />}
    </Shell>
  );
};
